import styled from 'styled-components';

export const ControlContainer = styled.div`
    .control_sections{
        position: relative;
        left: 10px;
        top: 56px;
    }
   .control_sections .ant-card {
        background-color:#33363C !important;
        color: #ffffff !important;
        box-shadow: none;
    }
   .control_sections .ant-card-body {
        padding: 8px;
    }
   .control_sections .control_addButton {
        background-color: #33363C;
        color: #ffffff;
        font-size: 14px;
        border-top: 1px solid #6A727C;
        width: 100%;
        display: flex;
        gap: 8px;
        align-items: center;
        padding: 10px 0px;
        cursor: pointer;
    }
    .control_addButton.no-border-top {
        border-top: none;
    }
   .control_sections .control_addButton:hover {
        color: #36BDBE !important;
    }
   .control_sections .control_addButton:hover svg path{
        stroke: #36BDBE !important;
    }
   .control_sections  button:focus {
        outline: unset;
        outline: unset;
    }
`;